import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'cn';
import { HugeiconsIcon } from '@hugeicons/react';
/*
 * Иконка поштучным путём - правило единицы 12: общий файл пакета
 * `@hugeicons/core-free-icons` не собирается на Linux.
 */
import Loading03Icon from '@hugeicons/core-free-icons/Loading03Icon';
/*
 * Тип пропов - у самой иконки, а не `svg`: в поставке стоит
 * `React.ComponentProps<'svg'>`, и `strokeWidth` там строка, а `HugeiconsIcon`
 * ждёт число. На macOS это молчит, `pnpm typecheck` - нет.
 */
function Spinner({ className, ...props }) {
    return (_jsx(HugeiconsIcon, { icon: Loading03Icon, strokeWidth: 2, "data-slot": "spinner", role: "status", "aria-label": "Loading", className: cn('size-4 animate-spin', className), ...props }));
}
export { Spinner };
//# sourceMappingURL=spinner.js.map